module.exports = __webpack_public_path__ + "img/adam_shaheen.ff3245bf.png";